import { FormEvent } from 'react'
import { ObjectTypes, useObjectActionMutation } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { useFormLayout } from '../layouts'
import { FormLayout } from '../layouts/form-layout'

type ActionModalProps<O extends keyof ObjectTypes> = {
	action: string
	layout: {
		object: O
		name: string
		dependencies?: Array<O>
	}
	parent: ObjectTypes[O]
	title: string
	onClose: VoidFunction
}

export function ActionModal<O extends keyof ObjectTypes>({
	action,
	layout,
	parent,
	title,
	onClose,
}: ActionModalProps<O>) {
	const { layout: formLayout } = useFormLayout(layout.object, layout.name)
	const { mutate, isPending } = useObjectActionMutation(
		layout.object,
		parent.id,
		action,
		layout.dependencies?.map(dependency => ['api', dependency]),
	)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		const formData = new FormData(event.currentTarget)
		const payload: Record<string, unknown> = Object.fromEntries(formData)
		mutate(payload, { onSuccess: () => onClose() })
	}

	return (
		<Dialog heading={title} isOpen onOpenChange={onClose}>
			<div className="m-4">
				<form className="space-y-4 m-auto max-w-[60em]" onSubmit={onSubmit}>
					<FormLayout data={parent} layout={formLayout} />
					<Button type="submit" isPending={isPending} isDisabled={isPending}>
						Uložit
					</Button>
				</form>
			</div>
		</Dialog>
	)
}
